import { setupApp } from 'bd-common/src/setupApp';
import { config } from './config';

setupApp(config).then((app) => {
  app.$mount('#app');
});
